module.exports = __webpack_public_path__ + "img/easter_dress_with_flowers.fe7ab799.jpg";